import { z } from 'zod';

import { NotificationTypeSchema } from './types';

/**
 * Internal SYNC send-template wire contract (phone-otp-verification milestone).
 *
 * customer service calls `POST /internal/send-template` on whatsapp-integration to
 * dispatch a Meta UTILITY template INLINE and read the outcome synchronously — unlike
 * the async `OutboundNotification` bus path, the result is needed in the same request
 * so the send doubles as the "is this a WhatsApp number" check.
 *
 * `vars` are the named template body vars (keyed by `NOTIFICATION_VARS[notificationType]`),
 * same shape as the bus envelope. `language` is the requested Meta language code
 * (e.g. `pt_BR`); the integrator falls back to the template's own language when the
 * requested one is not approved.
 */
export const SendTemplateRequestSchema = z.object({
  notificationType: NotificationTypeSchema,
  to: z.string().min(1),
  vars: z.record(z.string(), z.string()),
  language: z.string().min(1).optional(),
});
export type SendTemplateRequest = z.infer<typeof SendTemplateRequestSchema>;

/**
 * Result of a sync send. `not_whatsapp` = Meta rejected the recipient (the number has
 * no WhatsApp / is undeliverable); `send_failed` = any other failure (rate limit,
 * template/config error, network). `wamid` is present only on `sent`.
 */
export const SendTemplateResultSchema = z.object({
  status: z.enum(['sent', 'not_whatsapp', 'send_failed']),
  wamid: z.string().optional(),
});
export type SendTemplateResult = z.infer<typeof SendTemplateResultSchema>;
